import React from 'react';
import { Modal, Button } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

interface NoAccountModalProps {
    visible: boolean;
    onClose: () => void;
}

export const NoAccountModal: React.FC<NoAccountModalProps> = ({ visible, onClose }) => {
    const navigate = useNavigate();

    return (
        <Modal
            visible={visible}
            content={
                <div>
                    <div className="py-4 text-center">
                        {t('pages.login.noAccountMessage')}
                    </div>
                    <div className="flex gap-3 px-4 pb-2">
                        <Button
                            block
                            fill="outline"
                            onClick={onClose}
                            className="text-sm"
                        >
                            {t('pages.login.cancel')}
                        </Button>
                        <Button
                            block
                            color="primary"
                            onClick={() => {
                                onClose();
                                navigate('/driver/register');
                            }}
                            className="text-sm"
                        >
                            {t('pages.login.goToRegister')}
                        </Button>
                    </div>
                </div>
            }
            closeOnAction
            onClose={onClose}
        />
    );
};

